import {
  GET_TESTIMONIALS,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAIL,
  GET_TESTIMONIAL_DETAILS,
  GET_TESTIMONIAL_DETAILS_SUCCESS,
  GET_TESTIMONIAL_DETAILS_FAIL,
  CREATE_TESTIMONIAL,
  CREATE_TESTIMONIAL_SUCCESS,
  CREATE_TESTIMONIAL_FAIL,
  UPDATE_TESTIMONIAL,
  UPDATE_TESTIMONIAL_SUCCESS,
  UPDATE_TESTIMONIAL_FAIL,
  DELETE_TESTIMONIAL,
  DELETE_TESTIMONIAL_SUCCESS,
  DELETE_TESTIMONIAL_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  testimonials: {
    testimonials: [],
    total: "",
    page: "",
  },
  testimonialDetails: {},
  error: {},
  loading: false,
}

const Testimonial = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Testimonial - This line cannot be edited or removed
    case GET_TESTIMONIALS:
    case GET_TESTIMONIAL_DETAILS:
    case CREATE_TESTIMONIAL:
    case UPDATE_TESTIMONIAL:
    case DELETE_TESTIMONIAL:
      return {
        ...state,
        loading: true,
      }

    case DELETE_TESTIMONIAL_FAIL:
    case GET_TESTIMONIALS_FAIL:
    case GET_TESTIMONIAL_DETAILS_FAIL:
    case UPDATE_TESTIMONIAL_FAIL:
    case CREATE_TESTIMONIAL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_TESTIMONIALS_SUCCESS:
      return {
        ...state,
        testimonials: action.payload,
        error: {},
        loading: false,
      }

    case GET_TESTIMONIAL_DETAILS_SUCCESS:
      return {
        ...state,
        testimonialDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        testimonials: {
          ...state.testimonials,
          testimonials: [action.payload, ...state.testimonials.testimonials],
          total: state.testimonials.total + 1,
        },
        testimonialDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        testimonials: {
          ...state.testimonials,
          testimonials: state.testimonials.testimonials.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        testimonialDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        testimonials: {
          ...state.testimonials,
          testimonials: state.testimonials.testimonials.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default Testimonial
